/* Project Import will be here */
import { getBannerApi, getBannerViewApi } from "services/home";
import { getErrorObject } from "utilities/utils";
import { IBannerDetailsParams } from "models/homeModels";
import { mergeAndNormalizeProducts, types as productTypes, initialFilterState } from "reducers/products";
/* Project Import will be here */

export const types = {
  BANNER_REQUEST: "home/BANNER_REQUEST",
  BANNER_SUCCESS: "home/BANNER_SUCCESS",
  BANNER_FAILURE: "home/BANNER_FAILURE",
  BANNER_DETAILS_REQUEST: "home/BANNER_DETAILS_REQUEST",
  BANNER_DETAILS_SUCCESS: "home/BANNER_DETAILS_SUCCESS",
  BANNER_DETAILS_FAILURE: "home/BANNER_DETAILS_FAILURE"
};

const initialState = {
  /* Banner List */
  isLoading: false,
  data: [],

  /* Banner Details */
  isBannerDetailsLoading: false,
  bannerDetails: {},

  error: null
};

export const banners = (state = initialState, action) => {
  switch (action.type) {
    /* Banner list */
    case types.BANNER_REQUEST:
      return { ...initialState, isLoading: true };

    case types.BANNER_SUCCESS:
      return { ...action.payload, error: null, isLoading: false };

    case types.BANNER_FAILURE:
      return { ...state, isLoading: false, error: action.payload.error };

    /* Banner details */
    case types.BANNER_DETAILS_REQUEST:
      return { ...state, isBannerDetailsLoading: true };

    case types.BANNER_DETAILS_SUCCESS:
      return { ...state, ...action.payload, error: null, isBannerDetailsLoading: false };

    case types.BANNER_DETAILS_FAILURE:
      return { ...state, isBannerDetailsLoading: false, error: action.payload.error };

    /* Common */
    default:
      return state;
  }
};

/* Get banner images and video to render in home page */
export const getBannersList = () => {
  return async dispatch => {
    dispatch({ type: types.BANNER_REQUEST });
    try {
      /* Get banner images or videos from API */
      const response = await getBannerApi();

      dispatch({
        type: types.BANNER_SUCCESS,
        payload: { data: response.data.Data }
      });
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.BANNER_FAILURE, payload: { error: message } });
    }
  };
};

/* Get banner details and products */
export const getBannerDetailsAndProducts = (bannerId) => {
  return async (dispatch, getState) => {
    dispatch({ type: types.BANNER_DETAILS_REQUEST });

    /* For SKU type banners restore the product reducer */
    dispatch({ type: productTypes.PRODUCTS_REQUEST, payload: { filter: { ...initialFilterState } } });
    try {
      const requestParam: IBannerDetailsParams = {
        Page: 1,
        Sorting: getState().appSettings.defaultProductSorting,
        FilterLevelCode: "SKU",
        FilterIdList: [bannerId]
      };

      const response = await getBannerViewApi(requestParam);
      const bannerDetails = response.data.Data;

      /* Assign the banner details */
      dispatch({ type: types.BANNER_DETAILS_SUCCESS, payload: { bannerDetails: bannerDetails } });

      /* Assign the banner product to product reducer */
      dispatch(mergeAndNormalizeProducts(bannerDetails.Products, response.data.Count, response.data.TotalCount));
    }
    catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.BANNER_DETAILS_FAILURE, payload: { error: message } });

      await dispatch(getBannersList());
    }
  };
};